import React from 'react'

import * as S from './styles'

/**
 * @typedef {Object} ModalProps
 *
 * @property {React.ReactNode} children
 * @property {'right' | 'center' | 'left' | 'apart'} [position]
 */

/**
 * @param {ModalProps} props
 */
export default function Group({ position, children }) {
  return (
    <>
      <S.Group position={position}>{children}</S.Group>
    </>
  )
}
